module.exports = __webpack_public_path__ + "img/icon-shopping-bag.80419085.svg";